<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useSessionStore } from '@/store/useSessionStore'

const session = useSessionStore()
const route = useRoute()

// Force component remount when the active project changes so views reload their data.
const routerKey = computed(() => (route.params.id || route.params.projectId) as string ?? '')

async function checkSession() {
  if (!session.isAuthenticated) return
  await session.fetchSession()
}

function onVisibilityChange() {
  if (document.visibilityState === 'visible') checkSession()
}

onMounted(() => document.addEventListener('visibilitychange', onVisibilityChange))
onUnmounted(() => document.removeEventListener('visibilitychange', onVisibilityChange))
</script>

<template>
  <RouterView :key="routerKey" />
</template>
